<template>
  <transition enter-active-class="animated slideInRight">
    <nav
      v-if="isActive"
      id="sidebar"
      v-click-outside="showMenu"
      :class="{ active: isActive }"
    >
      <div class="sidebar-header" @click="showMenu()">
        <icon icon="x" class="close-slider" />
      </div>
      <ul class="list-unstyled components">
        <li>
          <div class="sidebar-logo text-center mb-5">
            <img src="@/assets/images/logo.png" alt class="my-0 mr-md-auto" />
          </div>
        </li>
        <li class="user-profile">
          <a @click.prevent="fn_myProfile">
            <span class="pr-3">
              <icon icon="user" class="icon" />
            </span>
            {{ $t("my_profile") }}
          </a>
        </li>
        <li class="signout">
          <a @click="fn_logout()">
            <span class="pr-3">
              <icon icon="log-out" class="icon" />
            </span>
            {{ $t("signOut") }}
          </a>
        </li>
        <li class="order-list">
          <a @click="fn_goto('order_list')">
            <span class="pr-3">
              <icon icon="list" class="icon" />
            </span>
            {{ $t("order_list") }}
          </a>
        </li>
        <li v-if="langs.length >= 0">
          <a
            href="#pageSubmenu"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle collapsed"
          >
            <span class="pr-3">
              <icon icon="globe" class="icon" />
            </span>
            {{ $t("lang") }}
          </a>
          <ul id="pageSubmenu" class="list-unstyled collapse" style>
            <li v-for="lang in langs" :key="lang.name" class="pl-4">
              <a href="#" @click="setLocale(lang.code)">{{ lang.name }}</a>
            </li>
          </ul>
        </li>

        <li>
          <a
            href="#pageSubmenu"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle collapsed"
          >
            <span class="pr-3">
              <icon icon="globe" class="icon" />
            </span>
            {{ $t("Setting") }}
          </a>
        </li>

        <li v-if="currencies.length >= 0">
          <a
            href="#currency"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle collapsed"
          >
            <span class="pr-3">
              <icon icon="dollar-sign" class="icon" />
            </span>
            {{ $t("currency") }}
          </a>
          <ul id="currency" class="list-unstyled collapse" style>
            <li v-for="cus in currencies" :key="cus.id" class="pl-4">
              <a href="#" @click="setCurrency(cus)">{{ cus.title }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </transition>
</template>
<script>
import { loadMessages } from "../plugins/i18n";
import { mapGetters } from "vuex";
import store from "@/store";
import Swal from "sweetalert2";
import Toast from "@/plugins/toast";
export default {
  name: "NavVertical",
  layout: "cashier",
  middleware: "auth",
  data: () => ({
    lang: {},
  }),
  computed: {
    ...mapGetters({
      isActive: "nav/navLang",
      user: "auth/user",
      langs: "lang/locales",
      local: "lang/locale",
      currencies: "auth/currencies",
      order_items: "items/order_items",
      rate: "currency/selected_currency",
    }),
  },
  watch: {
    local: function (value) {
      this.setLang();
    },
  },
  mounted() {
    this.setLang();
  },
  created() {
    this.$store.dispatch("lang/fetchLangs");
  },
  methods: {
    setLang() {
      let vm = this;
      let lang = _.find(this.langs, function (el) {
        return el.code === vm.local;
      });
      this.lang = lang;
    },
    fn_myProfile() {
      this.$store.dispatch("popup/updateFooterAction", true);
      if (this.order_items.length > 0) {
        Swal.fire({
          title: this.$t("confirm_goto_menu_title"),
          text: this.$t("confirm_goto_menu_text"),
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("ok"),
          cancelButtonText: this.$t("cancel"),
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("order/clear_order", true);
            this.$store.dispatch("customer/resetCustomerState");
            this.$store.dispatch("location/resetLocationState");
            this.$store.dispatch("order_list/fetchSelectStatus", 0);
            this.$router.push({ name: "user_profile" }).catch((err) => {});
          } else {
            return;
          }
        });
      } else {
        this.$router.push({ name: "user_profile" }).catch((err) => {});
      }
      this.$store.dispatch("nav/collapse_lang_inactive", false);
    },
    setLocale(locale) {
      if (this.$i18n.locale !== locale) {
        loadMessages(locale);
        this.$store.dispatch("lang/setLocale", { locale });
      }
      this.$store.dispatch("nav/collapse_lang_inactive", false);
    },
    showMenu() {
      this.$store.dispatch("nav/collapse_lang_active");
    },
    openPage(page) {
      this.$router.push(page);
      this.showMenu();
    },
    setCurrency(currency) {
      this.$store.dispatch("currency/setCurrency", currency);
      this.$store.dispatch("nav/collapse_lang_inactive", false);
    },
    fn_goto(url) {
      if (this.order_items.length > 0) {
        Swal.fire({
          title: this.$t("confirm_goto_menu_title"),
          text: this.$t("confirm_goto_menu_text"),
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("ok"),
          cancelButtonText: this.$t("cancel"),
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("order/clear_order", true);
            this.$store.dispatch("customer/resetCustomerState");
            this.$store.dispatch("location/resetLocationState");
            this.$store.dispatch("order_list/fetchSelectStatus", 0);
            this.$router.push({ name: url }).catch((err) => {});
          } else {
            return;
          }
        });
      } else {
        this.$router.push({ name: url }).catch((err) => {});
      }
      this.$store.dispatch("nav/collapse_lang_inactive", false);
    },
    fn_logout() {
      if (this.order_items.length > 0) {
        Swal.fire({
          title: "Are you sure Sign Out?",
          text: "Your order will be lose.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            Swal.fire("Success!", "success");
            this.$store.dispatch("customer/resetCustomerState", true);
            this.$store.dispatch("customer/getCustomerStatus", true);
            this.$store.dispatch("location/resetLocationState", true);
            this.$store.dispatch("location/getLocationStatus", true);
            this.$store.dispatch("order/clear_order", true);
            this.$store.dispatch("items/getOrderItemsStatus", true);
            this.$store
              .dispatch("auth/signOut")
              .then(() => {
                Toast.fire({
                  icon: "success",
                  title: "Signed out successfully",
                });
                this.$router.push({ name: "login" });
              })
              .catch((err) => {});
          }
        });
      } else {
        this.$store.dispatch("customer/resetCustomerState", true);
        this.$store.dispatch("customer/getCustomerStatus", true);
        this.$store.dispatch("location/resetLocationState", true);
        this.$store.dispatch("location/getLocationStatus", true);
        this.$store.dispatch("order/clear_order", true);
        this.$store.dispatch("items/getOrderItemsStatus", true);
        this.$store
          .dispatch("auth/signOut")
          .then(() => {
            Toast.fire({
              icon: "success",
              title: "Signed out successfully",
            });
            this.$router.push({ name: "login" });
          })
          .catch((err) => {});
      }
    },
  },
};
</script>
<style scoped>
.icon {
  height: 20px !important;
}
.icon:hover {
  transform: scale(1.5);
  background: #fff;
}
.user-profile,
.signout,
.order-list {
  cursor: pointer;
}
.signout {
  border-bottom: 1px solid rgba(17, 17, 17, 0.2);
  margin-bottom: 10px;
}
.sidebar-logo > img {
  width: 150px;
}
.close-slider {
  cursor: pointer;
}
#sidebar {
  background: white;
  color: black;
  transition: all 0.3s;
  width: 100%;
  height: 100%;
  box-shadow: 25px 6px 19px 18px black;
  top: 0;
}
.logo {
  max-width: 200px;
  margin-left: -45px;
  float: left;
}
.nav-button {
  margin-right: -15px !important;
}

#sidebar .sidebar-header {
  padding: 20px;
}

#sidebar ul.components {
  padding: 20px 0;
}

#sidebar ul p {
  color: black;
  padding: 10px;
}

#sidebar ul li a {
  padding: 5px;
  font-size: 1.3em;
  padding-left: 30px;
  /* text-transform: uppercase; */
  display: block;
}

#sidebar ul li a:hover {
  color: #7386d5;
  background: #fff;
}

#sidebar ul li.active > a,
a[aria-expanded="true"] {
  color: black;
  background: white;
}

a[data-toggle="collapse"] {
  position: relative;
}

.dropdown-toggle::after {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

ul ul a {
  font-size: 1.2em !important;
  padding-left: 30px !important;
  background: white;
}

ul.CTAs {
  padding: 20px;
}

ul.CTAs a {
  text-align: center;
  font-size: 0.9em !important;
  display: block;
  border-radius: 5px;
  margin-bottom: 5px;
}

a.download {
  background: #fff;
  color: black;
}
a {
  color: black;
}
a.article,
a.article:hover {
  background: whitesmoke !important;
  color: black !important;
}
#content {
  width: 100%;
  padding: 20px;
  min-height: 100vh;
  transition: all 0.3s;
}

#sidebar {
  margin-right: -100%;
  float: right;
}
#sidebar.active {
  margin-right: 0;
  position: fixed;
  z-index: 1031;
  max-width: 340px;
  right: 0px;
}
#sidebarCollapse span {
  display: none;
}
</style>